export class AddConnectionUnit {
    constructor(connection, diagram) {
        this.connection = connection;
        this.diagram = diagram;
        this.title = 'New connection';
    }
    undo() {
        this.diagram.remove(this.connection, false);
    }
    redo() {
        this.diagram._addConnection(this.connection, false);
    }
}
